import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EChartOption, ECharts } from 'echarts';
import * as echarts from 'echarts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { HttpClient } from '@angular/common/http';
import { DrillDownMapService } from './drill-down-map.service';
import { ChartOptionService } from '../../service/chart-option.service';
import { ChartResizeService } from '../../service/chart-resize.service';

@Component({
  selector: 'bcac-drill-down-map',
  templateUrl: './drill-down-map.component.html',
  styleUrls: ['./drill-down-map.component.scss']
})
export class DrillDownMapComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private drillDownMapService: DrillDownMapService,
    private chartOptionService: ChartOptionService,
    private chartResizeService: ChartResizeService,
    private http: HttpClient
  ) { }

  chartTitle = {
    show: true,
    label: "图表标题"
  };

  customToolbox = {
    show: true
  }

  // 布局设置
  cardPadding = "1rem";
  cardBgColor = "#fff";
  chartTitleColor = "";

  // echart图表元素
  chartBackgroundColor: string = "#FFF";
  chartColors: string[] = this.chartOptionService.getChartColors('default');
  chartTitles = this.chartOptionService.getChartTitle();
  chartLegend = this.chartOptionService.getChartLegend();
  chartGeo = this.drillDownMapService.getChartGeo();
  chartTextStyle = this.chartOptionService.getTextStyle();
  chartVisualMap = this.chartOptionService.getPiecewiseVisualMap();
  scatterSeries: EChartOption.Series = this.drillDownMapService.getMapScatterSeries();
  chartTooltip: EChartOption.Tooltip = this.drillDownMapService.getScatterMapTooltip();
  chartSeriesList: EChartOption.Series[] = [];


  chartOption = {
    backgroundColor: this.chartBackgroundColor,
    title: this.chartTitle,
    geo: this.chartGeo,
    visualMap: this.chartVisualMap,
    series: this.chartSeriesList,
    color: this.chartColors,
    tooltip: this.chartTooltip,
    textStyle: this.chartTextStyle
  }
  /* 
    @Input 区域
  */
  @Input()
  set bcacDarkMode(darkMode: boolean) {
    if (darkMode == true) {
      this.drillDownMapService.changeChartTitleDark(this, darkMode);
      this.drillDownMapService.chartBackgroundColorDarkMode(this.chartOption);
      this.drillDownMapService.colorsDarkMode(this.chartColors);
      this.drillDownMapService.seriesDarkMode(this.scatterSeries);
    }
  }

  @Input()
  set bcacVisualMapPosition(position: 'left' | 'right') {
    this.drillDownMapService.setVisualMapPosition(this.chartVisualMap, position)
  }

  _mapUrl: string = "";
  @Input()
  set bcacMapUrl(mapUrl: string) {
    this._mapUrl = mapUrl;
  }

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }

  // 加载等待
  _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  @Input()
  set bcacDimension(dimension) {
    this.drillDownMapService.setVisualMapDimension(this.chartVisualMap, dimension);
  }

  @Input()
  set bcacDimensionNames(dimensionNames) {
    this.drillDownMapService.setDimensionNames(this.scatterSeries, dimensionNames, this.chartTooltip)
  }

  @Input()
  set bcacChartData(chartData) {
    this.drillDownMapService.buildSeries(chartData, this.chartVisualMap, this.chartSeriesList, this.scatterSeries);

    this.updateMapUrl();
  }

  @Input()
  set bcacTitleSwitch(titleSwitch: boolean) {
    this.chartTitle.show = titleSwitch;
  }

  @Input()
  set bcacTitle(title: string) {
    this.chartTitle.label = title;
  }


  @Output() bcacDataSourceSelectEmit: EventEmitter<any[]> = new EventEmitter<any[]>();

  // Echarts 实例
  echartInstance: ECharts = null;
  onOptionInit(ec) {
    if (ec) {
      this.echartInstance = ec;
      this.echartInstance.on('geoselectchanged', (param) => {
        let selected = param.batch[0].name;
        let innerMap;
        this.http.get(this._mapUrl).subscribe(((geoJson: any) => {
          for (const key in geoJson.features) {
            if (Object.prototype.hasOwnProperty.call(geoJson.features, key)) {
              const element = geoJson.features[key];
              if (element.properties.name == selected) {
                innerMap = Object.assign({}, { type: 'FeatureCollection', features: [element] })
              }
            }
          }
          echarts.registerMap('subDistrict', innerMap)
          this.echartInstance.setOption({
            geo: {
              map: 'subDistrict'
            }
          })
        }))
      })
    }
  }
  // 选择数据源切换
  dataSourceChange($event) {
    let selectareaname = ''
    let innerMap
    if ($event[0]) {
      selectareaname = $event[0];
    }
    if (this.isRegisted) {

      if (selectareaname == '全市') {
        this.echartInstance.setOption({
          geo: {
            map: 'myMap'
          }
        })
      } else if (selectareaname == '远郊区') {
        this.echartInstance.setOption({
          geo: {
            map: 'far',
          }
        })
      } else if (selectareaname == '近郊区') {
        this.echartInstance.setOption({
          geo: {
            map: 'near',
          }
        })
      } else {
        this.http.get(this._mapUrl).subscribe((geoJson: any) => {
          // for (const index in bjgeoJson.features) {
          //   if (bjgeoJson.features[index].properties.name == selectareaname) {
          //     innerMap = Object.assign({}, { type: `FeatureCollection`, features: [bjgeoJson.features[index]] })
          //   }
          // }
          for (const key in geoJson.features) {
            if (Object.prototype.hasOwnProperty.call(geoJson.features, key)) {
              const element = geoJson.features[key];
              if (element.properties.name == selectareaname) {
                innerMap = Object.assign({}, { type: 'FeatureCollection', features: [element] })
              }
            }
          }
          echarts.registerMap("subDistrict", innerMap)
          this.echartInstance.setOption({
            geo: {
              map: 'subDistrict',
            }
          })
        })
      }


    }


    this.bcacDataSourceSelectEmit.emit($event)


  }

  options;
  // echart配置项
  initEchart() {
    this.options = this.chartOption;
  }

  async getGeoJson(url) {
    return await this.http.get(url).toPromise();
  }


  // updateOption() {
  //   if (this.echartInstance) {
  //     this.echartInstance.setOption(this.options, true);
  //   }
  // }
  isRegisted: boolean = false;
  updateMapUrl() {
    this.isRegisted = false;
    this.http.get(this._mapUrl).subscribe((geoJson: any) => {
      let farareas = ['延庆区', '怀柔区', '密云区', '昌平区', '顺义区', '平谷区', '门头沟区', '通州区', '房山区', '大兴区']
      let nearareas = ['海淀区', '东城区', '西城区', '朝阳区', '石景山区', '丰台区']
      let farfeatures = []
      let nearfeatures = []
      let farinnerMap;
      let nearinnerMap;

      for (const index in geoJson.features) {
        for (const item of farareas) {
          if (geoJson.features[index].properties.name == item) {
            farfeatures.push(geoJson.features[index])
          }
        }
        for (const item of nearareas) {
          if (geoJson.features[index].properties.name == item) {
            nearfeatures.push(geoJson.features[index])
          }
        }
      }
      farinnerMap = Object.assign({}, { type: `FeatureCollection`, features: farfeatures})
      nearinnerMap = Object.assign({}, { type: `FeatureCollection`, features: nearfeatures})
      
      echarts.registerMap("far", farinnerMap)
      echarts.registerMap("near", nearinnerMap)
      echarts.registerMap('myMap', geoJson);

      this.isRegisted = true;

      if (this.echartInstance) {
        this.echartInstance.setOption(this.options, true)
      }
    })
  }
  // 图表重置
  chartRestore() {
    if (this.echartInstance) {
      // this.echartInstance.setOption({
      //   geo: {
      //     map: 'myMap'
      //   }
      // })
      this.echartInstance.dispatchAction({ type: 'restore' })
    }
  }

  ngOnInit() {
    this.initEchart();


    this.updateMapUrl();
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoMapResizeAdapt(this.echartInstance, this.options);
    })
  }

  returnMap() {
    if (this.echartInstance) {
      this.echartInstance.setOption({
        geo: {
          map: 'myMap'
        }
      })
    }
  }
}
